/**
 * EZCones Footer Behavior
 * Phase 10 §5 mobile accordion + §4 email capture validation.
 * Form submission is now native Shopify {% form 'customer' %} — JS only
 * provides client-side email validation. No fetch/AJAX submission.
 * Scoped to ezcones-footer-v2.liquid section. No external dependencies.
 */
(function () {
  'use strict';

  var BREAKPOINT_MOBILE_MAX = 749;

  function isMobile() {
    return window.matchMedia('(max-width: ' + BREAKPOINT_MOBILE_MAX + 'px)').matches;
  }

  /* ---------------------- Accordion (Columns 2 + 3) ---------------------- */

  function setColumnState(column, expanded) {
    var toggle = column.querySelector('[data-footer-col-toggle]');
    var content = column.querySelector('.ez-footer-col__content');
    if (!toggle || !content) return;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (expanded) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '0';
    }
  }

  function initAccordions(root) {
    var columns = root.querySelectorAll('.ez-footer-col--linklist');
    if (!columns.length) return;

    function applyForViewport() {
      var mobile = isMobile();
      columns.forEach(function (col) {
        var toggle = col.querySelector('[data-footer-col-toggle]');
        var content = col.querySelector('.ez-footer-col__content');
        if (!toggle || !content) return;
        if (mobile) {
          // Start collapsed on mobile
          setColumnState(col, false);
        } else {
          // Always expanded on desktop
          toggle.setAttribute('aria-expanded', 'true');
          content.style.maxHeight = 'none';
        }
      });
    }

    columns.forEach(function (col) {
      var toggle = col.querySelector('[data-footer-col-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function (e) {
        if (!isMobile()) return; // No-op on desktop
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        setColumnState(col, !expanded);
      });
    });

    applyForViewport();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyForViewport, 150);
    });
  }

  /* ---------------------- Email Capture client-side validation ---------------------- */

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
  }

  function showMessage(form, kind) {
    // Only toggle the JS-driven 'invalid' state — success/error are server-rendered.
    var invalidEl = form.querySelector('.ez-footer-capture__message--invalid');
    if (!invalidEl) return;
    if (kind === 'invalid') {
      invalidEl.hidden = false;
    } else {
      invalidEl.hidden = true;
    }
  }

  function initEmailCapture(root) {
    var wrap = root.querySelector('.ez-footer-capture');
    if (!wrap) return;
    var form = wrap.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput) return;
      var email = emailInput.value.trim();

      if (!isValidEmail(email)) {
        e.preventDefault();
        showMessage(form, 'invalid');
        return;
      }

      // Clear invalid state and let the form submit natively to Shopify.
      showMessage(form, null);
    });

    // Hide invalid message as soon as user starts editing again
    var emailInput = form.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        showMessage(form, null);
      });
    }
  }

  /* ---------------------- Init ---------------------- */

  function init() {
    var roots = document.querySelectorAll('[data-ezcones-footer-v2]');
    roots.forEach(function (root) {
      initAccordions(root);
      initEmailCapture(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
